import styled from 'styled-components';

import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';

/*
 * Style.
 */

export const StyledActivityRulePillLinkIcon = styled(Icon)`
  display: inline-block;
  margin-bottom: -3px;
`;

export const StyledActivityRulePillLearnMoreDiv = styled.div`
  height: 100%;

  & > ${StyledActivityRulePillLinkIcon} {
    color: ${(p) => p.theme.greys.shade60};
  }

  &:hover > ${StyledActivityRulePillLinkIcon} {
    color: ${(p) => p.theme.greys.shade70};
  }
`;
